<!--
<h1 mat-dialog-title> {{isNew ? "Nouvelle conversation"  : "Conversation i " }}</h1>
-->

<div class="conversation-dialog">
  <div class="title">
    <h4>{{conversation.carDetails}}</h4>
    <h6><b>Participants: </b>{{conversation.participants}}</h6>


    <!-- {{data.objectSource}} {{data.carId}} {{data.objectId}} -->
  </div>

  <div mat-dialog-content class="messages">
    <form #conversationDialog="ngForm" >

      @for (message of conversation.messages; track message; let j = $index) {
        <div class="message" [style]="(currentUserId === message.senderId)?'background-color:#eeeeee; margin-right:30%':'background-color:#e0ffff; margin-left:30%'" >
          <h6> <b>{{(currentUserId === message.senderId)?'Moi': message.senderName }}</b>: {{message.body}}</h6>
          <span class="date"> {{dateFormat(message.created)}}</span>
        </div>
      }

    </form>
  </div>

  <div mat-dialog-actions class="message-reply">

    <mat-form-field>
      <textarea  matInput type="text"  name="reply" placeholder="Message"  [(ngModel)]="reply" ></textarea>
    </mat-form-field>

    <button [disabled]="reply ===''" class="cta-button-buy"  mat-button (click)="sendMessage();$event.stopPropagation()">
      <mat-icon>send</mat-icon>
    </button>

    <!--
    <button class ="simple-button" [disabled] = !conversationDialog.valid mat-button [mat-dialog-close]="data" cdkFocusInitial> {{isNew ? "Créer"  : "Enregistrer " }} </button>

    <button class ="simple-button" mat-button [mat-dialog-close]="">Fermer</button>
    -->

  </div>
</div>
